import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { PREOWNED_ENABLED, PREOWNED_HOME, usePreownedMode } from "../themes";

/** Where the "back to main admin" segment lands. */
const MAIN_HOME = "/watches-list";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    margin: theme.spacing(0, 1.5, 1),
    padding: 2,
    borderRadius: 6,
    backgroundColor: "rgba(0,0,0,0.22)",
    border: "1px solid rgba(255,255,255,0.12)",
  },
  seg: {
    flex: 1,
    textAlign: "center",
    padding: theme.spacing(0.5, 0),
    fontSize: "0.72rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
    borderRadius: 4,
    textDecoration: "none",
    color: "rgba(255,255,255,0.55)",
    transition: "background-color 120ms ease, color 120ms ease",
    "&:hover": {
      color: "#fff",
      backgroundColor: "rgba(255,255,255,0.08)",
    },
  },
  // `&:hover` (0,2,0) outranks a bare `.active` (0,1,0), so the base hover would
  // repaint the selected segment. Re-assert the active colors under hover too.
  active: {
    cursor: "default",
    color: ({ accent }) => (accent ? "#1E232B" : "#2a4468"),
    backgroundColor: ({ accent }) => accent || "#fff",
    "&:hover": {
      color: ({ accent }) => (accent ? "#1E232B" : "#2a4468"),
      backgroundColor: ({ accent }) => accent || "#fff",
    },
  },
}));

/**
 * Segmented control switching between the main and pre-owned admins. Rendered
 * by both sidebars; the active side is derived from the route, so it can never
 * disagree with the page. `accent` colors the active segment to match whichever
 * sidebar it sits in. Renders nothing when the pre-owned admin is disabled.
 */
export function PreownedSwitchButton({ accent }) {
  const isPreowned = usePreownedMode();
  const classes = useStyles({ accent });
  if (!PREOWNED_ENABLED) return null;

  const seg = (active, to, label) =>
    active ? (
      <span className={`${classes.seg} ${classes.active}`}>{label}</span>
    ) : (
      <Link to={to} className={classes.seg}>
        {label}
      </Link>
    );

  return (
    <div className={classes.root}>
      {seg(!isPreowned, MAIN_HOME, "Main")}
      {seg(isPreowned, PREOWNED_HOME, "Pre-Owned")}
    </div>
  );
}
export default PreownedSwitchButton;